import { useDispatch, useSelector } from 'react-redux';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { selectUserBtagPrefix } from '@/store/selectors/combined.selectors';
import { useEffect } from 'react';
import { getPromotions } from '@/store/cms/promotions/actions';

export const usePromotionsLoader = () => {
  const locale = useSelector(selectLocale);
  // The saga sends this btag prefix with the request. It resolves to the logged-in user's
  // `reference` when available (overriding any URL btag), otherwise the URL/cookie btag.
  // Subscribing to it re-fetches promotions once the user loads after login / auto-login,
  // so the request carries the reference btag instead of being stuck with the value from
  // the initial (pre-auth) load.
  const userBtagPrefix = useSelector(selectUserBtagPrefix);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!locale) {
      return;
    }

    dispatch(getPromotions());
  }, [locale, userBtagPrefix]);
};
